<div [loading]="loading">
  <div *ngIf="!loading">
    <h1>Schválení způsobu řešení záboru</h1>

    <fieldset>
      <legend>Řešení záboru</legend>
      <div class="flexbox-container">
        <div class="column-33">
          <div class="info-label">Parcela</div>
          <cell-parcel
            [parcel]="occupationObject.parcel"
            [occupation]="occupationObject"
            [cellClass]="''">
          </cell-parcel>
        </div>
        <div class="column-33">
          <div class="info-label">Zábor</div>
          <cell-occupation
            [occupation]="occupationObject"
            [visibleApprove]="false">
          </cell-occupation>
        </div>
        <div class="column-33">
          <div class="info-label">Navrhovaný stav</div>
          <div><strong>{{ occupationObject.finalSolutionType?.name }}</strong></div>
          <ng-container *ngIf="occupationObject.finalSolutionReasonCancellation">
            <div class="info-label mt-10">Důvod zrušení</div>
            <p style="white-space: pre-wrap">{{ occupationObject.finalSolutionReasonCancellation }}</p>
          </ng-container>
        </div>
      </div>
    </fieldset>

    <div class="actions">
      <gmt-button [clickAction]="onApprove">Schválit</gmt-button>
    </div>

    <fieldset>
      <legend>Důvod zamítnutí</legend>
      <div class="column-100">
        <label class="required">Text poznámky</label>
        <textarea [(ngModel)]="occupationObject.finalSolutionNote" rows="5"></textarea>
      </div>
    </fieldset>

    <div class="actions">
      <gmt-button [clickAction]="onReject" [gmtDisabled]="!occupationObject.finalSolutionNote" class="red">Zamítnout</gmt-button>
    </div>
  </div>
</div>
